import React, { useState, Suspense, useEffect, useContext, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    SendFeatureSuggestion, ShowFeatureSuggestion
} from "./Services/SuggestAFeatureService";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { GetFAQList } from "../../../../Services/Global-Services/GlobalServices";
import moment from "moment";
import { Paginator } from 'primereact/paginator';
const ComponentLoader = React.lazy(() =>
    import("../../../../Shared/Sidebar/ComponentLoader")
);
const SuggestAfeature = () => {
    const toster = useContext(TostMsg);
    const [featureSuggestionList, setFeatureSuggestionList] = useState([]);
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "");
    const [faqLists, setFAQLists] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loader, setLoading] = useState(false);
    const [text, setText] = useState("");
    let userDetails = JSON.parse(localStorage.getItem("User") || "");
    const [suggestAFeatureDes, SetSuggestAFeatureDes] = useState('');
    const [activeFAQIndex, setActiveFAQIndex] = useState(null);

    useEffect(() => {
        GetSuggestaFeature(currentPage, rowsPerPage);
        GetMasterSystemAlertList();
        GetFAQs()
    }, [])


    useEffect(() => {
        if (featureSuggestionList && featureSuggestionList.length > 0) {
            GetSuggestaFeature(currentPage, rowsPerPage);
        }
    }, [featureSuggestionList, currentPage, rowsPerPage]);

    async function GetSuggestaFeature(pageNumber, pageSize) {
        setLoading(true)
        const body = {
            loggedInEmpId: userDetails?.EmpId || "",
            PageNumber: pageNumber + 1,
            PageSize: pageSize
        };
        try {
            let response = await ShowFeatureSuggestion(body);
            setFeatureSuggestionList(response?.Data);
            setTotalRecords(response?.Data?.Totalfeedbackcount);
            setLoading(false);
        } catch (error) {
            toster.current.error(ERROR_LIST?.SuggestionFeature);
            setLoading(false);
        }
    }


    async function SaveSuggestionFeature() {
        setLoading(true)
        const body = {
            Feedback: text
        };
        try {
            const response = await SendFeatureSuggestion(body);
            if (response) {
                GetSuggestaFeature(currentPage, rowsPerPage);
                setText("");
                setLoading(false);
                toster.current.success(response?.Message);
            }
        } catch (err) {
            setLoading(false);

        }
    }

    const GetMasterSystemAlertList = useCallback(async (message, type) => {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 0) {
                toster.current.success(msg?.Desc)
            } else if (msg?.Name == 'SuggestFeature_Description') {
                SetSuggestAFeatureDes(msg?.Desc);
            }
        });
    }, [])

    async function GetFAQs() {
        setLoading(true);
        const body = {
            FAQTypeId: 102,
        };
        try {
            const response = await GetFAQList(body);
            setFAQLists(response?.Data);

        } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
        } finally {
            setLoading(false);
        }
    }

    const onPageChange = (e) => {
        setCurrentPage(e.page);
        setRowsPerPage(e.rows);
        GetSuggestaFeature(e.page, e.rows);
    };

    return (
        <div>
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>
            </div>

            <div className="container-fluid">
                <div className="row g-3">
                    <div className="">
                        <div className="col-md-12">
                            <div className="card">
                                <img src="images/org-img/leave/popup-backimg.png" style={{ position: "absolute", right: "0", width: "100%", opacity: "0.4" }} />
                                <div className="card-body" style={{ padding: "3rem" }}>
                                    <div className="block-header">
                                        <div className="rightfeed-form center1">
                                            <h2>Suggest A Feature</h2>
                                            <p>{suggestAFeatureDes}</p>
                                            <div className="give-rate">
                                                <span className="block-heading">Suggest A Feature</span></div>
                                            <div className="form-group d-flex">
                                                <textarea className="form-control" rows="6" placeholder="Please type here..." required onChange={(event) => setText(event?.target?.value)} value={text}></textarea>
                                            </div>
                                            <button className="sendfeed" type="button" onClick={() => SaveSuggestionFeature()} disabled={text.length <= 3}>submit</button>
                                        </div>
                                    </div>
                                    <div className="latest-feedreview">
                                        <div className="me-auto" style={{ padding: "1rem 0rem 0rem 0rem", textAlign: "center" }}>
                                            <h2 className="font-w600 mb-0">History</h2>
                                        </div>
                                        <div className="col-xl-12 mt-4  historylist">
                                            <table className="table table-bordered table-hover">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col" style={{ width: "298px" }}>Suggestion</th>
                                                        <th scope="col">Response</th>
                                                        <th scope="col">Created Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {featureSuggestionList?.orgEmpFeedbackListResponse?.map((el, index) => (
                                                        <tr key={index}>
                                                            <td scope="row">{index + 1}</td>
                                                            {/* <td scope="row">{el.CreatedDate}</td> */}
                                                            <td>{el.Feedback ? el.Feedback : 'N/A'}</td>
                                                            <td>{el.Response ? el.Response : 'N/A'}</td>
                                                            {/* <td>{el.ModifiedDate}</td> */}
                                                            <td scope="row">{moment(el?.CreatedDate).format("MMM DD YYYY")}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="paginations">
                                            <Paginator first={currentPage * rowsPerPage} 
                                            rows={rowsPerPage} 
                                            totalRecords={totalRecords} 
                                            rowsPerPageOptions={[10, 20, 30]}
                                             onPageChange={onPageChange} 
                                             />
                                             </div>
                                        </div>
                                        <div className="me-auto mt-4" style={{ padding: "1rem 0rem 0rem 0rem", textAlign: "center" }}>
                                            <h2 className="font-w600 mb-0">Frequently Asked Questions</h2>
                                        </div>
                                        <div className="col-xl-12 faqlist" >
                                            <div className="accordion">
                                                <div className="row" >                                                    
                                                    {faqLists?.map((el, index) => (
                                                      <div className="col-md-6" key={index}>
                                                      <div className="accordion-item">
                                                       <h2 className="accordion-header" id={`heading-${index}`}>
                                                        <button
                                                     className={`accordion-button ${activeFAQIndex === index ? '' : 'collapsed'}`}
                                                      type="button"
                                                      onClick={() =>
                                                      setActiveFAQIndex(prev => (prev === index ? null : index))
                                                          }
                                                      aria-expanded={activeFAQIndex === index}
                                                      aria-controls={`collapse-${index}`}
                                                          >
                                                       {el.Question}
                                                      </button>
                                                      </h2>
                                                        <div
                                                     id={`collapse-${index}`}
                                                     className={`accordion-collapse collapse ${activeFAQIndex === index ? 'show' : ''}`}
                                                     aria-labelledby={`heading-${index}`}
                                                     >
                                                    <div className="accordion-body">
                                                     <p>{el.Answer}</p>
                                               </div>
                                             </div>
                                           </div>
                                          </div>
                                            ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="contact-manager">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title m-auto">Contact Your Reporting Manager htmlFor Any Leave Clarifications</h5>
                        </div>
                        <div className="modal-body text-center">
                            <form>
                                <div className="form-group text-left">
                                    <label>Repoting Manager</label>
                                    <select className="default-select form-control wide mb-3">
                                        <option selected disabled>Select reporting manager</option>
                                        <option>Arun Mishra</option>
                                        <option>Pragya Tiwari</option>
                                        <option>Alisha Goyal</option>
                                    </select></div>
                                <div className="form-group text-left">
                                    <label className="mt-3">Reason</label>
                                    <textarea rows="4" cols="1" className="form-control"></textarea></div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger light" data-bs-dismiss="modal">Decline</button>
                            <button type="button" className="btn btn-primary">Accept</button>
                        </div>
                    </div>
                </div>
            </div>
            {loader ? (
                <Suspense >
                    <ComponentLoader />
                </Suspense>
            ) : (
                ""
            )}
        </div>
    )
}
export default SuggestAfeature